import React from 'react';
import className from 'classnames';
import moment from 'moment';
import TableHeader from '../TableHeader';
import KillPalButton from './KillPalButton';
import RevivePalButton from './RevivePalButton';

const NftList = ({
  title,
  nfts
}) => {
  return (
    <React.Fragment>
      <div className="User__header">
        <h3 className="User__header__h3 User__header__upper-space">{title}</h3>
      </div>
      <div
        className={className('Table', {
          'Table--nfts-list': true
        })}
      >
        {(() => {
          let columnHeaders = [
            {
              label: 'Image'
            },
            {
              label: 'ID'
            },
            {
              label: 'Token id'
            },
            {
              label: 'description'
            },
            {
              label: 'Current earned EMPL'
            },
            {
              label: 'Deposited at'
            },
            {
              label: 'Died At'
            },
            {
              label: 'Actions'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {nfts.map((nft) => (
          <div
            className='Table__row'
            key={nft.id}
            data-x={nft}
          >
            <div className='Table__col'>
              <img
                src={nft.image}
                width={60}
                height={60}
              />
            </div>
            <div className='Table__col'>{nft.attributes.id}</div>
            <div className='Table__col'>{nft.token_id}</div>
            <div className='Table__col'>{nft.description}</div>
            <div className='Table__col'>{nft.attributes.current_earned_empl}</div>
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: nft.attributes.deposited_at !== null ?
                    moment(nft.attributes.deposited_at * 1000).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: nft.died_at && nft.died_at !== null ?
                    moment(nft.died_at * 1000).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div className='Table__col'>
              { (nft.died_at) && <RevivePalButton tokenId={nft.tokenId} /> }
              { (!nft.died_at && nft.attributes.state === 'hatched') && <KillPalButton tokenId={nft.tokenId} /> }
            </div>
          </div>
        ))}
        {nfts.length == 0 && <div className='Table__row'>
          <div className='Table__col'>
            Nothing to show here
          </div>
        </div>}
      </div>
    </React.Fragment>
  );
}

export default NftList;
